import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import Cookies from "js-cookie";
import { Box, CircularProgress } from "@material-ui/core";
import { ACCOUNT_PIN_RESET } from "../../apis/configuration";
import { handleApi } from "../../apis";
import { useWalletContext } from "../../context/WalletContext";

const RequireAuth = ({ children }) => {
  const location = useLocation();

  const { user, handleLoginInDB, handleLogoutInDB } = useAuthContext();
  const { setKYCVerified, setEMIVerified, handleCheckEMIStatus } =
    useWalletContext();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    handleAuth();
  }, []);

  const handleAuth = async () => {
    try {
      let number = localStorage.getItem("phone_number");
      let tempUserId = Cookies.get("tempUserId");
      if (number || tempUserId) {
        if (!tempUserId) {
          await handleCheckEMIStatus(navigate);
        }
        if (!user) {
          await handleLoginInDB(number, tempUserId, navigate);
          const response = await handleApi(
            ACCOUNT_PIN_RESET,
            { phone_number: number },
            null,
            navigate,
            { "Api-Key": process.env.REACT_APP_API_KEY },
          );
          setKYCVerified(!!response?.verified);
          setIsLoading(false);
        }
      } else {
        if (user) {
          await handleLogoutInDB(navigate);
        }
      }
    } catch (error) {
      setKYCVerified(false);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Box className="AuthLoader">
      <CircularProgress color="newFontColor" />
    </Box>
  ) : user ? (
    children
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
